<template>
  <base-dialog
  ref="base"
  v-model="model"
  width="500"
  :title="$t(`dialogs.titles.${preview ? 'previewFiles' : 'attachFiles'}`)"
  header-bg="blue">
    <select-attachments-list
    class="mt-4"
    :attachments.sync="attachmentsProps"
    :max="10"
    :max-size="50"
    unit="MB"
    :disabled="preview"/>
  </base-dialog>
</template>
<script>
import BaseDialog from '@/components/dialogs/BaseDialog'
import SelectAttachmentsList from '@/components/lists/dynamic/SelectAttachmentsList'
// import PrimaryBtn from '@/components/btns/PrimaryBtn'
export default {
  components: {
    // PrimaryBtn,
    BaseDialog,
    SelectAttachmentsList
  },
  props: {
    value: Boolean,
    attachments: {
      type: Array,
      required: true
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    },
    attachmentsProps: {
      get: function() {
        return this.$props.attachments
      },
      set: function(v) {
        this.$emit('update:attachments', v)
      }
    }
  }
}
</script>
<style>

</style>